import {PRODUCTION} from '../../config';

export const getAssetsPrefix = (assetPath: string) => {
  const base = (process.env.PUBLIC_URL || '') + '/images/';
  return (base + assetPath).replace(/\/+/, '/');
};